import { render } from "./ShowImageModal.vue?vue&type=template&id=01212512&scoped=true"
import script from "./ShowImageModal.vue?vue&type=script&lang=js"
export * from "./ShowImageModal.vue?vue&type=script&lang=js"

import "./ShowImageModal.vue?vue&type=style&index=0&id=01212512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01212512"]])

export default __exports__